import './dropdown-friend-plus.scss'

import { Link } from 'gatsby'
import React from 'react'

import BalloonDropdown from '../../../../../../ui/BalloonDropdown'

interface DropDownFriendPlusProps {
  setIsShowDropDown: React.Dispatch<React.SetStateAction<boolean>>
}

const dataLinksToDropdown = [
  {
    label: 'Clube +amigo',
    href: '/clube',
  },
  {
    label: 'Cartão +amigo',
    href: '/cartao/cartonista',
  },
]

const DropDownFriendPlus = ({ setIsShowDropDown }: DropDownFriendPlusProps) => {
  return (
    <div className="dropDownFriendPlus">
      <BalloonDropdown>
        <div className="dropDownFriendPlus-list-items">
          {dataLinksToDropdown.map((itemLink) => (
            <Link
              to={itemLink.href}
              className="dropDownFriendPlus-link"
              onClick={() => setIsShowDropDown(false)}
            >
              {itemLink.label}
            </Link>
          ))}
        </div>
      </BalloonDropdown>
    </div>
  )
}

export default DropDownFriendPlus
